export default __webpack_public_path__ + "static/media/20_zurie_collins.36bf7596.jpg";